/**
 * The desktop team surface (M4): a people list on the left, the selected person on the right.
 *
 * `Table` keeps the classic data table (Branch Details console, legacy settings routes); `Panel` is the
 * master-detail used by "Ma branche → Équipe" and "Paramètres → Équipe". Phones always keep their own list.
 */
export enum TeamPresentation {
  Table = "table",
  Panel = "panel",
}

/** Search params the panel keeps in the URL (replace, never push), so a selection survives a reload or a link. */
export enum TeamPanelSearchParam {
  View = "view",
  Person = "person",
}

/** What one person can do in a module, read from the roles they hold here. */
export enum ModuleAccessLevel {
  None = "none",
  View = "view",
  Edit = "edit",
}

/** Invitation statuses as the API spells them (lowercase). */
export enum InvitationListStatus {
  All = "__all__",
  Pending = "pending",
  Accepted = "accepted",
  Declined = "declined",
  Revoked = "revoked",
  Expired = "expired",
}
